export const CONFIG = window.__env;
export const POLLING_TIME_LIMIT_IN_MIN = 10;
